//AreaSelectingTable
import React, { useEffect, useState, useRef, ChangeEvent } from "react";
import { AreasTablePropsTypes } from "../../popupComp/PopupTypes";
import { FlatAdmin } from "../../createWarningComp/CreateWarningTypes";
import {
	maldivesAdministrativeLevel,
	sriLankaAdministrationLevel,
} from "../../createWarningComp/FixedDataSet";
import { flatMap, paginationList } from "../../createWarningComp/CommonMethods";
import { CloseIcon, DownIcon, UpIcon } from "../../iconSet/IconSet";

const maldivesAreas = [
	"Malé",
	"Hulhumalé",
	"Addu City",
	"Fuvahmulah",
	"Hithadhoo",
	"Thinadhoo",
	"Kulhudhuffushi",
	"Dhidhdhoo",
];

const AreasTable = (props: AreasTablePropsTypes) => {
	const [numberOfRows, setNumberOfRows] = useState<number>(10);
	const [selectedCodes, setSelectedCodes] = useState<Set<string>>(
		new Set<string>()
	);
	//const [selectedAreas, setSelectedAreas] = useState<Set<string>>(new Set());

	const [filterTableData, setFilterTableData] = useState<FlatAdmin[]>([]);
	const [selectedArea, setSelectedArea] = useState<string[]>([]);
	const [tableData, setTableData] = useState<FlatAdmin[]>([]);

	const [pagedAreas, setPagedAreas] = useState<FlatAdmin[][]>([]);
	const [pagination, setPagination] = useState<FlatAdmin[][]>([]);
	const [selectedPagination, setSelectedPagination] = useState<number>(0);

	const sliceCountRef = useRef<HTMLInputElement>(null);
	const searchRef = useRef<HTMLInputElement>(null);

	// true = A -> Z
	// false = Z -> A
	const [areaSort, setAreaSort] = useState<Boolean>(true)
	const areaSortHandle = () => {
		setAreaSort(prevState => !prevState)
	}
	useEffect(() => {
		setFilterTableData(prevState => {
			return [...prevState].sort((a, b) => {
				const areaComparison = areaSort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
				return areaComparison
			})
		})
	}, [areaSort])

	const [adminLevelSort, setAdminLevelSort] = useState<Boolean>(true)
	const adminLevelSortHandle = () => {
		setAdminLevelSort(prevState => !prevState)
	}
	useEffect(() => {
		setFilterTableData(prevState => {
			return [...prevState].sort((a, b) => {
				const adminLevelComparison = adminLevelSort ? a.adminLevel.localeCompare(b.adminLevel) : b.adminLevel.localeCompare(a.adminLevel)
				return adminLevelComparison
			})
		})
	}, [adminLevelSort])

	useEffect(() => {
	if (props.areas && props.areas.length > 0) {
		const incomingSet = new Set(props.areas);
		const areEqual =
			props.areas.length === selectedCodes.size &&
			props.areas.every((code) => selectedCodes.has(code));

		if (!areEqual) {
			setSelectedCodes(incomingSet);
		}
	}
}, [props.areas]);

	const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			setSelectedArea((prevState) => [...prevState, event.target.name]);
		} else {
			setSelectedArea((prevState) =>
				prevState.filter((item) => item !== event.target.name)
			);
		}
	};

	// Selected country
	const country = process.env.REACT_APP_COUNTRY;

	useEffect(() => {
		if (country === "SRI_LANKA") {
			const flat = flatMap(sriLankaAdministrationLevel, selectedArea);
			setTableData(flat);
			// setFilterTableData(prevState => {
			// 	return [...flat].sort((a, b) => {
			// 		const areaComparison = areaSort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
			// 		return areaComparison
			// 	})
			// })
			setFilterTableData(flat);
		} else if (country === "MALDIVES") {
			const flat = flatMap(maldivesAdministrativeLevel, selectedArea);
			setTableData(flat);
			// setFilterTableData(prevState => {
			// 	return [...flat].sort((a, b) => {
			// 		const areaComparison = areaSort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
			// 		return areaComparison
			// 	})
			// })
			setFilterTableData(flat);
		}
	}, [selectedArea]);

	useEffect(() => {
		setPagination(paginationList(filterTableData, numberOfRows));
	}, [tableData, filterTableData, numberOfRows]);

	useEffect(() => {
		paginateAreas();
	}, [filterTableData, numberOfRows]);

	const paginateAreas = () => {
		const pages: FlatAdmin[][] = [];
		for (let i = 0; i < filterTableData.length; i += numberOfRows) {
			pages.push(filterTableData.slice(i, i + numberOfRows));
		}

		setPagination(pages);

		// Only reset to page 0 if the current page is out of bounds
		setSelectedPagination((prev) => (prev < pages.length ? prev : 0));
	};

	const handleSliceCountChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = Number(e.target.value);
		if (value > 0) setNumberOfRows(value);
	};

	// Handle table search
	const handelSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
		if (event.target.value === "") {
			setFilterTableData(tableData);
		} else {
			setFilterTableData((prevState) =>
				prevState.filter((item) =>
					item.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
					item.adminLevel.toLowerCase().includes(event.target.value.toLowerCase())
				)
			);
		}
	};

	const [localSelectedCodes, setLocalSelectedCodes] = useState<Set<string>>(
		new Set()
	);

	useEffect(() => {
		props.onSelect(Array.from(selectedCodes));
	}, [selectedCodes]);

	const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
		handleCheckBox(event);

		setSelectedCodes((prev) => {
			const updated = new Set(prev);
			if (event.target.checked) {
				updated.add(event.target.name);
			} else {
				updated.delete(event.target.name);
			}
			return updated;
		});
	};

	const paginationNavigation = (side: "next" | "prev") => {
		if (side === "next") {
			if (pagination.length > selectedPagination + 1) {
				setSelectedPagination((prevState) => prevState + 1);
				//console.log(">>>> good next");
			}
		} else if (side === "prev") {
			if (0 <= selectedPagination - 1) {
				setSelectedPagination((prevState) => prevState - 1);
			}
		}
	};

	const handleSelectAllCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
		const isChecked = event.target.checked

		setSelectedCodes(() => {
			if (isChecked) {
				return new Set(filterTableData.map((area) => area.code));
			} else {
				return new Set();
			}
		});
	}

	return (
		<div
			style={{ width: "100%" }}
			className="subTable-wrapper" /* style={{ maxWidth: 500, margin: "auto", fontFamily: "Arial, sans-serif" }} */
			
		>
			<span className="main-title">Select Areas</span>
			<div className="field-wrapper">
				<div className="left">
					<span>
						show{" "}
						<input
							type="number"
							ref={sliceCountRef}
							defaultValue={numberOfRows}
							min={1}
							onChange={handleSliceCountChange}
						/>{" "}
						Entries
					</span>
				</div>
				<div className="right">
					<span>
						{" "}
						search{" "}
						<input
							type="text"
							ref={searchRef}
							onChange={handelSearchChange}
							placeholder="Search here"
						/>
					</span>
				</div>
			</div>
			<div className="table-body">
				<div className="table-wrapper">
						<div className="table-row header" style={{ gridTemplateColumns: `4rem 1fr 1fr`, width: '100%' }} >
							<span>
								<input type="checkbox" className='select-all-checkbox' onChange={(e) => handleSelectAllCheckbox(e)}/>
							</span>
							<span onClick={(e) => areaSortHandle()}>
								Area
								<div>
									{areaSort ? (
										<UpIcon width="1rem" color="var(--color-main-white)" />
									) : (
										<DownIcon width="1rem" color="var(--color-main-white)" />
									)}
								</div>
							</span>
							<span onClick={(e) => adminLevelSortHandle()}>
								Administration Level
								<div>
									{adminLevelSort ? (
										<UpIcon width="1rem" color="var(--color-main-white)" />
									) : (
										<DownIcon width="1rem" color="var(--color-main-white)" />
									)}
								</div>
							</span>
						</div>
					</div>
				
				{pagination[selectedPagination]?.map((area, index) => (
					<div key={index} className="table-wrapper">
						<div className="table-row" style={{ gridTemplateColumns: `4rem 1fr 1fr`, width: '100%' }} >
							<span style={{ justifyContent: "center" }}>
								<input type="checkbox" onChange={(e) => handleCheckboxChange(e)} checked={selectedCodes.has(area.code)} name={area.code} />
							</span>
							<span>{area.name ? area.name : 'N/A'}</span>
							<span>{area.adminLevel ? area.adminLevel : 'N/A'}</span>
						</div>
					</div>
				))}
				{pagination.length === 0 && (
					<div className="table-no-data-wrapper">
						<span>no any data available</span>
					</div>
				)}
			</div>
				
			
			<div className="table-pagination-wrapper">
				{/* <div
					className="icon-page-box"
					style={{ marginBottom: "0.5rem" }}
					onClick={(e) => paginationNavigation("prev")}
				>
					&lt;
				</div> */}
				<div className="page-wrapper">
					{/* Show previous button if not on first page group */}
					{selectedPagination >= 6 && (
						<span
							className="icon-page-box"
							onClick={() =>
								setSelectedPagination(Math.max(0, selectedPagination - 6))
							}
						>
							&lt;&lt;
						</span>
					)}
					<div
						className="icon-page-box"
						style={{ marginBottom: "0.0rem" }}
						onClick={(e) => paginationNavigation("prev")}
					>
						&lt;
					</div>
					{/* Show current page group (10 pages at a time) */}
					{pagination
						.slice(
							Math.floor(selectedPagination / 6) * 6,
							Math.floor(selectedPagination / 6) * 6 + 6
						)
						.map((_, idx) => {
							const pageNumber = Math.floor(selectedPagination / 6) * 6 + idx;
							return (
								<span
									key={pageNumber}
									className={
										selectedPagination === pageNumber
											? "icon-page-box selected"
											: "icon-page-box"
									}
									onClick={() => setSelectedPagination(pageNumber)}
								>
									{pageNumber + 1}
								</span>
							);
						})}

					<div
						className="icon-page-box"
						style={{ marginBottom: "0.0rem" }}
						onClick={(e) => paginationNavigation("next")}
					>
						&gt;
					</div>

					{/* Show next button if there are more pages */}
					{Math.floor(selectedPagination / 6) * 6 + 6 < pagination.length && (
						<span
							className="icon-page-box"
							onClick={() =>
								setSelectedPagination(
									Math.min(
										pagination.length - 1,
										Math.floor(selectedPagination / 6) * 6 + 6
									)
								)
							}
						>
							&gt;&gt;
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default AreasTable;
